import React, { useState, useEffect } from "react";

import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import AppScreen from "./AppScreen";
import ListItem from "./ListItem/ListItem";
import { BackIcon, StarIcon } from "./Icons";
import { getCourseAsync } from "../redux/coursesReducer";
import TagButton from "./TagButton/TagButton";

const CourseDetails = ({ location }) => {
  const history = useHistory();

  const courses = useSelector((state) => state.courses.value);
  const initialState = {
    name: "",
    _id: "",
    tags: [],
    cost: 0,
    rating: 0,
    thumbnail: "https://picsum.photos/200/200",
    platform: "",
    description: "",
    educator: "",
    dateAdded: "",
    cUrl: "#",
    chUrl: "#",
  };

  const [course, setCourse] = useState(initialState);
  let ratingArray;

  if (course.rating !== undefined) {
    ratingArray = new Array(course.rating).fill(0);
  }
  const dispatch = useDispatch();

  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    if (courses.data === undefined) {
      dispatch(getCourseAsync(`/courses/course/${location.search}`));
    } else {
      const courseID = new URLSearchParams(location.search).get("courseID");
      const courseState = courses.data.filter((item) => item._id === courseID);
      setCourse({ ...course, ...courseState[0] });
    }
  }, []);

  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    if (courses.data === undefined) {
      dispatch(getCourseAsync(`/courses/course/${location.search}`));
    } else {
      const courseID = new URLSearchParams(location.search).get("courseID");
      const courseState = courses.data.filter((item) => item._id === courseID);
      setCourse({ ...course, ...courseState[0] });
    }
  }, [location.search]);

  useEffect(() => {
    if (courses.data !== undefined) {
      const courseID = new URLSearchParams(location.search).get("courseID");
      const courseState = courses.data.filter((item) => item._id === courseID);
      setCourse({ ...course, ...courseState[0] });
    }
  }, [courses.data]);

  const [showImage, setShowImage] = useState(false);

  return (
    <AppScreen>
      <div className="px-4 pt-28 md:px-14 pb-10">
        <div className="grid grid-cols-4 gap-4 min-h-screen">
          <div className="rounded-md col-span-full sm:col-span-2 xl:col-span-1 lg:h-auto bg-white shadow-lg p-4 flex flex-col items-center lg:items-stretch gap-3 relative">
            <div className="overflow-hidden mx-auto md:h-60 w-full lg:w-full flex justify-center items-center">
              {!showImage && (
                <div className="w-full rounded-md cursor-pointer absolute gradient-loader" />
              )}

              <img
                src={`${course.thumbnail}`}
                className={`rounded-md cursor-pointer bg-cover z-10 ${
                  showImage && "w-full"
                }`}
                alt=""
                loading="lazy"
                onLoad={() => setShowImage(true)}
              />
            </div>
            <div className="block sm:hidden mt-10 self-start">
              <div className="overflow-hidden mx-auto w-full lg:w-full">
                <CourseTitle
                  className="text-xl font-bold"
                  title={`${course.name}`}
                  tags={course.tags}
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3 md:mt-5 self-start">
              <h4 className="text-xl font-semibold mt-2 col-span-full">
                Course Details:
              </h4>
              <p className="text-md sm:text-lg text-gray-600 ">Provided by:</p>
              <p className="text-md sm:text-lg ">{`${course.platform}`}</p>
              <p className="text-md sm:text-lg text-gray-600 ">
                Instructed by:
              </p>
              <p className="text-md sm:text-lg ">{`${course.educator}`}</p>
              <p className="text-md sm:text-lg text-gray-500">Rating:</p>
              <p className="text-md sm:text-lg flex items-center">
                {ratingArray &&
                  ratingArray.map((item, index) => (
                    <span key={index} className="text-yellow-400 text-2xl">
                      <StarIcon />
                    </span>
                  ))}
              </p>
            </div>
            <div className="block sm:hidden self-start">
              <CourseDescription
                subTitle="text-lg font-semibold mt-10 mb-5"
                p="text-sm pb-10"
                description={course.description}
              />
            </div>
            <div className="flex flex-1 flex-col mt-5 lg:mt-10 items-center w-full sm:p-0 mb-10 z-10  bg-white sm:bg-transparent">
              <a
                target="_blank"
                rel="noreferrer"
                href={`${course.chUrl}`}
                className="shadow-lg p-3 w-full text-center uppercase tracking-wider font-semibold bg-indigo-500 hover:bg-indigo-400 sm:bg-indigo-600 sm:hover:bg-indigo-500 transition-colors duration-300 rounded-md text-white"
              >
                Get this course
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href={`${course.cUrl}`}
                className="p-3 mt-4 text-sm text-indigo-500 self-end"
              >
                Visit Site
              </a>
            </div>
          </div>
          <div className="p-10 bg-white rounded-md shadow-lg hidden sm:visible sm:col-span-2 xl:col-span-3 sm:grid auto-rows-min">
            <CourseTitle
              title={`${course.name}`}
              tags={course.tags}
              className="text-3xl font-semibold"
            />
            <div className="flex flex-col">
              <CourseDescription
                subTitle="text-xl font-semibold mt-10 mb-5"
                p=""
                description={course.description}
              />
              <button
                onClick={() => history.push("/courses")}
                className="flex justify-end self-end items-center mt-10 text-indigo-700 hover:underline"
              >
                <BackIcon />
                <p className="p-3 text-sm">Go Back</p>
              </button>
            </div>
          </div>
          {courses.data !== undefined &&
            Object.keys(courses.data).length > 1 && (
              <SimilarCourses
                courses={courses}
                thisCourseID={course._id}
                asFooter
              />
            )}
        </div>
      </div>
    </AppScreen>
  );
};

export default CourseDetails;

const CourseTitle = ({ title, tags, ...otherProps }) => {
  const history = useHistory();

  return (
    <div className="row-span-1">
      <h1 className={otherProps.className}>{title}</h1>

      {/* //tags */}
      <span className="flex gap-3 my-5 flex-wrap md:flex-nowrap max-w-full overflow-hidden ">
        {tags.map((tag) => (
          // <div className="tag-3 py-1 px-4 bg-indigo-200 text-xs rounded-full max-w-min truncate">
          //   {tag}
          // </div>
          <TagButton
            key={tag}
            tag={tag}
            handleClick={(tag) => history.push(`/courses?tags[in]=${tag}`)}
          />
        ))}
      </span>
    </div>
  );
};

const CourseDescription = ({ description, small, ...otherProps }) => {
  return (
    <>
      <h1 className={otherProps.subTitle}>Course description:</h1>
      <p
        className={`whitespace-pre-wrap leading-loose text-gray-700 ${
          otherProps.p !== "" && otherProps.p
        }`}
      >
        {description}
      </p>
    </>
  );
};

export const SimilarCourses = ({ courses, thisCourseID, asFooter }) => {
  return (
    <div
      className={`p-5 bg-white rounded-md shadow-lg ${
        asFooter && "col-span-4"
      }`}
    >
      <h2 className="text-xl font-semibold my-4 ">Similar courses:</h2>
      <div className="grid gap-12 grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
        {courses.data &&
          courses.data
            .filter((item) => item._id !== thisCourseID)
            .map((item) => (
              <ListItem
                key={item.name}
                title={item.name}
                by={item.platform}
                tags={item.tags}
                cost={item.cost}
                courseID={item._id}
                thumbnail={item.thumbnail}
                detailScreen
              />
            ))}
      </div>
    </div>
  );
};
